import PresetFeedScreen from '../PresetFeedScreen';

const MobileCreate = () => {
  return <PresetFeedScreen />;
};

export default MobileCreate;
